/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { getLedgerByCustomer, postLedger } from "src/shared/api";
import { singleLedger } from "src/shared/services/interfacev2";

const useSpecifiedLedger = (id: string, pageNumber: number, pageSize: number, includeHistory?: boolean, sortField?: string, sortOrder?: string) => {
  const [ledgers, setLedgers] = useState<singleLedger | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchLedgersAsync = (): Promise<void> => {
    return getLedgerByCustomer(id, pageNumber, pageSize, includeHistory, sortField, sortOrder)
      .then((res) => {
        setLedgers(res?.data.ledger);
      })
      .catch((error) => console.error(error));
  };

  const fetchLedgers = () => {
    if (!id) return;
    setLoading(true);
    getLedgerByCustomer(id, pageNumber, pageSize, includeHistory, sortField, sortOrder)
      .then((res) => {
        setLedgers(res?.data.ledger);
      })
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
  };

  const postAndRefresh = async (data: any): Promise<{ billNumber: string }> => {
    setLoading(true);
    try {
      const res = await postLedger(data);
      setLedgers(null);
      await fetchLedgersAsync();
      return { billNumber: res.data.billNumber };
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLedgers();
  }, [id, pageNumber, pageSize, includeHistory, sortField, sortOrder]);

  return { ledgers, loading, setLedgers, postAndRefresh };
};

export default useSpecifiedLedger;
